<template>
  <modal v-model="openModel" :max-width="550">
    <template #title>Stopping Criteria Metrics Help</template>
    <template #content>
      <p>
        This section displays metrics related to the stopping
        criteria, which determines when we can confidently conclude
        that at least 95% of the relevant references have been found.
      </p>
      <p>
        To recommend stopping, the following conditions must be met:
      </p>
      <ul>
        <li>
          the estimated number of remaining Relevant references is
          zero, and;
        </li>
        <li>
          the last 40 screened were determined to be Not Relevant.
        </li>
      </ul>
    </template>
    <template #actions>
      <action-button @click="openModel = false">Close</action-button>
    </template>
  </modal>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import Modal from '@/components/Common/Modal';

export default {
  name: 'StoppingCriteriaHelpModal',
  components: { ActionButton, Modal },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:open'],
  computed: {
    openModel: {
      get: function () {
        return this.open;
      },
      set: function (value) {
        this.$emit('update:open', value);
      },
    },
  },
};
</script>
